import { render, staticRenderFns } from "./SectionPolicy.vue?vue&type=template&id=732b4c00"
import script from "./SectionPolicy.vue?vue&type=script&lang=js"
export * from "./SectionPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports